import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Text } from '@chakra-ui/react';
import { FT_PI_AUTH0_LOGIN } from '@whitbread-eos/api';
import { analytics, encodeToBase64, REGISTER_BASKET_REF_COOKIE, setCookie, useAuth0Navigation, useCustomLocale, useFeatureToggle, useSemanticTypography } from '@whitbread-eos/utils';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import React from 'react';
import Button from '../Button';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function CreateAccount(_ref) {
  var basketReference = _ref.basketReference,
    bookerDetails = _ref.bookerDetails;
  var _useTranslation = useTranslation(['common']),
    t = _useTranslation.t;
  var router = useRouter();
  var _useCustomLocale = useCustomLocale(),
    language = _useCustomLocale.language,
    country = _useCustomLocale.country;
  var _useFeatureToggle = useFeatureToggle(),
    isAuth0Enabled = _useFeatureToggle[FT_PI_AUTH0_LOGIN];
  var _useAuth0Navigation = useAuth0Navigation(),
    navigateToSignup = _useAuth0Navigation.navigateToSignup;
  var getTypographyProps = useSemanticTypography();
  var handleClick = () => {
    if (isAuth0Enabled) {
      analytics.track('auth_sign_up_click', {
        authStep: 'sign_up_click'
      });
      navigateToSignup({
        email: bookerDetails === null || bookerDetails === void 0 ? void 0 : bookerDetails.email,
        firstName: bookerDetails === null || bookerDetails === void 0 ? void 0 : bookerDetails.firstName,
        lastName: bookerDetails === null || bookerDetails === void 0 ? void 0 : bookerDetails.lastName,
        basketReference: basketReference || ''
      });
    } else {
      var encodedValue = encodeToBase64(basketReference);
      setCookie(REGISTER_BASKET_REF_COOKIE, encodedValue, undefined);
      router.push("/".concat(country, "/").concat(language, "/account/register?reservationId=").concat(basketReference));
    }
  };
  return _jsxs(Box, _objectSpread(_objectSpread({}, wrapperStyle), {}, {
    children: [_jsx(Text, _objectSpread(_objectSpread(_objectSpread({}, headingLayoutStyles), getTypographyProps(headingLegacyTypography, headingSemanticTypography)), {}, {
      "data-testid": "createAccount-heading",
      children: t('booking.confirmation.createAccount.heading')
    })), _jsx(Text, _objectSpread(_objectSpread(_objectSpread({}, textLayoutStyles), getTypographyProps({}, textSemanticTypography)), {}, {
      "data-testid": "createAccount-text",
      children: t('booking.confirmation.createAccount.text')
    })), _jsx(Button, _objectSpread(_objectSpread({}, buttonStyles), {}, {
      "data-testid": "createAccount-button",
      variant: "secondary",
      onClick: handleClick,
      children: _jsx(Text, {
        children: t('booking.confirmation.createAccount.button')
      })
    }))]
  }));
}
var wrapperStyle = {
  w: 'full',
  border: '1px solid var(--chakra-colors-lightGrey1)',
  borderRadius: '3px',
  p: 'lg',
  mb: '2.5rem'
};
var headingLayoutStyles = {
  mb: 'lg'
};
var headingLegacyTypography = {
  fontWeight: 'semibold',
  fontSize: '2xl',
  lineHeight: '4'
};
var headingSemanticTypography = {
  textStyle: 'heading-m'
};
var textLayoutStyles = {
  mb: 'lg'
};
var textSemanticTypography = {
  textStyle: 'body-m-regular'
};
var buttonStyles = {
  width: '100%',
  maxWidth: '288px'
};